<template>
  <el-dialog :visible.sync="dialogVisible" title="修改密码" width="500px" @closed="handleClosed">
    <el-form label-width="80px" size="small" :rules="rules" ref="form" :model="form">
      <el-form-item label="旧密码" prop="oldPassword">
        <el-input placeholder="请输入旧密码" v-model="form.oldPassword" type="password"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input placeholder="请输入新密码" v-model="form.newPassword" type="password"></el-input>
      </el-form-item>

      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input placeholder="请输入新密码" v-model="form.confirmPassword" type="password"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { modifyPassword } from '@/api/auth';
import CryptoJS from 'crypto-js';

export default {
  props: {
    value: Boolean,
  },
  data() {
    const checkConfirmPassword = (rule, value, callback) => {
      if (value === this.form.newPassword) {
        return callback();
      }
      return callback(new Error('新密码和确认密码必须一致'));
    };
    return {
      dialogVisible: false,
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: checkConfirmPassword, trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    md5Password(password) {
      return CryptoJS.MD5(password).toString();
    },
    async handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            await modifyPassword({
              oldPassword: this.md5Password(this.form.oldPassword),
              newPassword: this.md5Password(this.form.newPassword),
            });
            this.dialogVisible = false;
            this.$emit('callback');
          // eslint-disable-next-line no-empty
          } catch (e) {}
        }
      });
    },
    handleClosed() {
      this.$refs.form.resetFields();
    },
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit('input', val);
    },
  },
  mounted() {
    this.dialogVisible = this.value;
  },
};
</script>
